module.exports = __webpack_public_path__ + "static/media/rsz_massan-005.b1054e56.jpg";